module.exports = __webpack_public_path__ + "static/img/trend.1548589b.png";